<div class="flex flex-row items-center gap-2">
  <button
    [id]="id + '-first-page'"
    class="flex items-center btn btn-pagination px-2"
    [disabled]="currentPage === 1"
    (click)="onPageChange(1)"
  >
    <span class="material-symbols-rounded">{{ keyboardDoubleLeft }}</span>
  </button>

  <button
    [id]="id + '-prev-page'"
    class="flex items-center btn btn-pagination px-2"
    [disabled]="currentPage === 1"
    (click)="onPageChange(currentPage - 1)"
  >
    &nbsp;&nbsp;
    <span class="material-symbols-rounded">{{ arrowBackIos }}</span>
  </button>

  <ng-container *ngFor="let pageNum of pageNumbers; let i = index">
    <button
      [id]="id + '-page-' + i"
      class="flex items-center btn btn-pagination body-default-regular"
      [class.bg-brand-orange]="currentPage.toString() === pageNum"
      [disabled]="pageNum === '...'"
      (click)="onPageNumClicked(pageNum)"
    >
      {{ pageNum }}
    </button>
  </ng-container>

  <button
    [id]="id + '-next-page'"
    class="flex items-center btn btn-pagination px-2"
    [disabled]="currentPage === totalPages"
    (click)="onPageChange(currentPage + 1)"
  >
    <span class="material-symbols-rounded">{{ arrowForwardIos }}</span>
  </button>

  <button
    [id]="id + '-last-page'"
    class="flex items-center btn btn-pagination px-2"
    [disabled]="currentPage === totalPages"
    (click)="onPageChange(totalPages)"
  >
    <span class="material-symbols-rounded">{{ keyboardDoubleRight }}</span>
  </button>
</div>
